import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import { lightTheme } from './themes/lightTheme';
import { darkTheme } from './themes/darkTheme';
import { darkIceTheme } from './themes/darkIce';

export const essityThemeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ThemeBlueprint.make({
      name: 'light',
      params: {
        theme: {
          id: 'light',
          title: 'Light',
          variant: 'light',
          icon: <LightIcon />,
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={lightTheme} children={children} />
          ),
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'dark',
      params: {
        theme: {
          id: 'dark',
          title: 'Dark',
          variant: 'dark',
          icon: <DarkIcon />,
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={darkTheme} children={children} />
          ),
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'dark-ice',
      params: {
        theme: {
          id: 'darkIce',
          title: 'Dark Ice',
          variant: 'dark',
          icon: <DarkIcon />,
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={darkIceTheme} children={children} />
          ),
        },
      },
    }),
  ],
});
